import { oauth2Instance } from '../../../common/services';

const GRIEVANCE_OBJECT_NAME = 'sclgrievances';

/**
 * Verify Loan Account
 * -------------------
 * Sends JSON payload, so Content-Type MUST be application/json
 */
export async function verifyLoanAccount(loanAccountNo) {
  const headers = await oauth2Instance.getHeaders();

  const response = await fetch(
    `${oauth2Instance.getPortalURL()}/o/sclservices/grievanceapi/loanandpersonaldetails`,
    {
      method: 'POST',
      headers,
      body: JSON.stringify({ 
        transactionId:'12345678',
      	loanAgreementNo: loanAccountNo
      	})
    }
  );

  if (!response.ok) {
    throw new Error('Failed to verify loan account');
  }

  return response.json();
}

/**
 * Generate Mobile OTP
 * -------------------
 * Uses Basic Auth + JSON body
 * NOTE: OK for local/UAT only. In production, proxy via backend.
 */
 
export async function sendMobileOtp(mobileNumber) {
  const headers = await oauth2Instance.getHeaders();
  const response = await fetch(
    `${oauth2Instance.getPortalURL()}/o/sclservices/token/generate-otp`,
    {
      method: 'POST',
      headers,
      body: JSON.stringify({
        mobile_number: mobileNumber,
        OTPPurpose: 'Raise Grievance'
      })
    }
  );
  if (!response.ok) {
    throw new Error('Failed to send OTP. Please try again.');
  }
  return response.json();
}

/**
 * Email OTP (stubbed for now)
 */
export async function sendEmailOtp(emailId) {
  const headers = await oauth2Instance.getHeaders();
  const response = await fetch(`${oauth2Instance.getPortalURL()}/o/sclservices/token/generate-otp`,
    {
      method: 'POST',
      headers,
      body: JSON.stringify({
        email: emailId,
        OTPPurpose: 'Raise Grievance'
      })
    }
  );

  if (!response.ok) {
    throw new Error('Failed to send OTP. Please try again.');
  }
  return response.json();
}

/**
 * Verify OTP (stubbed for now)
 */
export async function verifyOtp({ type, value, otp }) {
  const headers = await oauth2Instance.getHeaders();

  const payload = {
    OTP: otp
  };

  // Dynamically add the correct field
  if (type === 'mobile') {
    payload.mobile_number = value;
  } else if (type === 'email') {
    payload.email = value;
  }

  const response = await fetch(
    `${oauth2Instance.getPortalURL()}/o/sclservices/token/validate-otp`,
    {
      method: 'POST',
      headers,
      body: JSON.stringify(payload)
    }
  );

  if (!response.ok) {
    throw new Error('Invalid OTP. Please try again.');
  }

  return response.json();
}
/**
* Get bank name and the account number
* ------------------------------------
* Parameters: loanAccountNo , transactionId
*/
export async function getTrancheAndBankDetails(loanAccountNo) {
  const headers = await oauth2Instance.getHeaders();
  const response = await fetch(
    `${oauth2Instance.getPortalURL()}/o/sclservices/grievanceapi/trancheandbankdetails`,
    {
      method: 'POST',
      headers,
      body: JSON.stringify({
        transactionId: '1720692599452',
        loanAgreementNo: loanAccountNo
      })
    }
  );

  if (!response.ok) {
    throw new Error('Failed to fetch tranche and bank details');
  }

  return response.json();
}


/**
 * Submit Grievance
 * ----------------
 * Uses multipart/form-data
 * IMPORTANT: Do NOT set Content-Type manually
 */
export async function submitGrievance(data, siteId) {
  const formData = new FormData();

  formData.append('firstName', data.firstName);
  formData.append('lastName', data.lastName);
  formData.append('emailId', data.email);
  formData.append('mobileNumber', data.mobileNumber);
  formData.append('citizenship', data.citizenship);
  formData.append(
    'haveAlreadyRequested',
    data.requestedBefore === 'yes'
  );
  formData.append(
    'haveLoanAccount',
    data.hasLoanAccount === 'yes'
  );
  formData.append('selectQueryType', data.queryType);
  formData.append('writeYourGrievance', data.grievanceMessage);
  formData.append('bankName', data.bankName || '');
  formData.append('bankAccountNumber', data.bankAccountNumber || '');
  formData.append('serviceRequestNumber',data.serviceRequestNumber || '');
  
  formData.append('scopeGroupId', siteId);

  if (data.attachmentFile) {
    formData.append('uploadFile', data.attachmentFile);
  }

  // Clone OAuth headers (do NOT mutate original)
  const authHeaders = await oauth2Instance.getHeaders();
  const headers = { ...authHeaders };

  // Remove Content-Type so browser sets multipart boundary
  delete headers['Content-Type'];
  delete headers['content-type'];

  const response = await fetch(
    `${oauth2Instance.getPortalURL()}/o/sclservices/scl-forms/customer-new-grievance`,
    {
      method: 'POST',
      body: formData,
      headers: {
        ...headers,
        Accept: 'application/json'
      }
    }
  );

  const text = await response.text();
  let result = {};

  if (text) {
    try {
      result = JSON.parse(text);
    } catch {
      console.warn('Non-JSON response from grievance API:', text);
    }
  }

  if (!response.ok || result.success === false) {
    throw new Error(result.message || 'Grievance submission failed');
  }

  return result;
}

export async function trackGrievanceBySRN(caseId) {
  const baseHeaders = await oauth2Instance.getHeaders();

  const headers = {
    ...baseHeaders,
    Messageid: '123456',
    Payloadkey: 'Payloadkey',
    Payloadname: 'EmailCaseCombinedDetailsByCaseId',
    Servicename: 'CaseDetail',
    Sourceapplicationname: 'website',
    PageSourceName:'grievance',
    'Content-Type': 'application/json'
  };

  const response = await fetch(
    `${oauth2Instance.getPortalURL()}/o/sclservices/grievanceapi/emailcasedetailsbycaseid?caseid=${encodeURIComponent(caseId)}`,
    {
      method: 'GET',
      headers
    }	
  );

  if (!response.ok) {
    throw new Error('Invalid Service Request Number');
  }

  return response.json();
}